module.exports = __webpack_public_path__ + "static/media/ic-warning.72de8755.svg";